import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  IconButton,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import TablePagination from "@mui/material/TablePagination";

const GroupOrderList = (props) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer
      component={Paper}
      elevation={3}
      style={{ maxHeight: "500px"}}
    >
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell>
              NUMEROS DE ORDEN{" "}
              {props.dateStart
                ? "| FECHAS: ( " + props.dateStart + " / " + props.dateEnd + " )"
                : ""}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.orders?.length > 0 ? (
            props.orders
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((order, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        margin: "0px -5px",
                      }}
                    >
                      <span>{order.id}</span>
                      <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => {
                            props.findInfoOrder(order.uuid);
                          }}
                        >
                          <DescriptionIcon />
                        </IconButton>
                      </div>
                    </div>
                  </TableCell>
                </TableRow>
              )
            )
          ) : (
            <TableRow>
              <TableCell>
                <p>No hay ordenes con los parametros solicitados...</p>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={props.orders?.length || 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
    
  );
};
export default GroupOrderList;
